module.exports = new __parcel__URL__("eccodarwin--dataset-cover.00d2a8bd.jpg").toString();